var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue";
var _hoisted_1 = { class: "fixed top-14 lg:top-20 left-[5%] right-[5%] sm:left-auto sm:right-[10%] flex flex-col gap-y-2" };
import { useNotificationSocket } from '@common/api/ws/hooks/useNotificationWebsocket';
import { computed, ref, watch } from 'vue';
import { useGetNotificationsSettingsQuery, RoleEnum } from '@common/graphql/operations';
import NotificationItem from '@common/components/Notifications/components/NotificationItem.vue';
import { useNotificationSound } from '@common/components/Notifications/hooks/useNotificationSound';
import { SoundSettingsEnum } from '@common/components/Notifications/enums/soundSettings.enum';
import CurrentApp from '@common/utils/CurrentApp';
import Auth from "@common/modules/auth";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsSocketPanel',
    setup: function (__props) {
        var appName = computed(function () { return CurrentApp.getInstance()._component.name; });
        var customer = computed(function () { return appName.value === 'AppStudent' ? RoleEnum.Student : RoleEnum.Teacher; });
        var isGuest = computed(function () { return Auth.isGuest(); });
        var notificationsSettingsResult = useGetNotificationsSettingsQuery(function () { return ({
            role: customer.value
        }); }, {
            enabled: !isGuest.value
        }).result;
        var sound = ref(SoundSettingsEnum.DISABLED);
        watch(notificationsSettingsResult, function (v) {
            if (!v)
                return;
            sound.value = v.notificationsSettings.sound;
        }, { immediate: true, deep: true });
        var play = useNotificationSound().play;
        var notifications = ref([]);
        useNotificationSocket(function (payload) {
            notifications.value = __spreadArray(__spreadArray([], __read(notifications.value), false), [payload], false);
            play(sound.value);
            setTimeout(function () {
                notifications.value = notifications.value.filter(function (item) { return item.id !== payload.id; });
            }, 4000);
        });
        var handleClose = function (id) {
            notifications.value = notifications.value.filter(function (item) { return item.id !== id; });
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, function (notification) {
                        return (_openBlock(), _createBlock(NotificationItem, {
                            key: notification.id,
                            notification: notification,
                            variant: "simplified",
                            onClose: handleClose
                        }, null, 8, ["notification"]));
                    }), 128))
                ])
            ]));
        };
    }
});
